import type { ObjectDirective } from 'vue';
import type { UseServerHighlightsParams } from './search-highlights';
import { addHighlightableElement, removeHighlightableElement, updateHighlightableElement } from './search-highlights';
import { featureFlags } from '../feature-flags/feature-flags';

export const searchHighlightable: ObjectDirective<HTMLElement, { useServerHighlight?: UseServerHighlightsParams }> = {
  mounted(el, { value }) {
    if (featureFlags.isEnabled('search-highlight')) {
      addHighlightableElement(el, value?.useServerHighlight);
    }
  },
  updated(el, { value }) {
    if (featureFlags.isEnabled('search-highlight')) {
      updateHighlightableElement(el, value?.useServerHighlight);
    }
  },
  beforeUnmount(el) {
    removeHighlightableElement(el);
  }
};
